// @ts-check
import BlockCard from '../BlockCard';

// Pipeline order and labels follow the backend AtelierProjectStage enum. The admin build cannot import /shared.
const STAGES = [
  ['submitted', 'Submitted'],
  ['reviewing', 'Reviewing'],
  ['nda_pending', 'NDA pending'],
  ['sample_dev', 'Sample in development'],
  ['sample_shipped', 'Sample shipped'],
  ['quoted', 'Quoted'],
  ['approved', 'Approved'],
  ['deposit_paid', 'Deposit paid'],
  ['in_production', 'In production'],
  ['qc', 'Quality check'],
  ['balance_paid', 'Balance paid'],
  ['shipped', 'Shipped'],
  ['delivered', 'Delivered'],
  ['cancelled', 'Cancelled'],
];

/** Pipeline bar of atelier projects per stage, with the longest wait for a reply called out. */
export default function AtelierBlock({ block }) {
  const { by_status: byStatus = {}, oldest_days: oldest = null } = block.data || {};
  const known = new Set(STAGES.map(([k]) => k));
  const rows = [
    ...STAGES.filter(([k]) => byStatus[k] > 0).map(([k, label]) => ({ key: k, label, count: byStatus[k] })),
    // Stages added to the backend enum later still show, with a readable fallback label.
    ...Object.keys(byStatus).filter((k) => !known.has(k) && byStatus[k] > 0).map((k) => ({ key: k, label: k.replace(/_/g, ' '), count: byStatus[k] })),
  ];
  const max = Math.max(0, ...rows.map((r) => r.count));

  return (
    <BlockCard title="Atelier" href={block.href} headline={block.headline}>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">No atelier projects yet</p>
      ) : (
        <>
          <ul className="space-y-2">
            {rows.map((r) => (
              <li key={r.key} data-testid="atelier-stage" className="text-sm">
                <div className="flex items-center justify-between">
                  <span>{r.label}</span>
                  <span className="font-medium">{r.count}</span>
                </div>
                <div className="mt-1 h-2 rounded bg-muted">
                  <div data-testid="atelier-bar" className="h-2 rounded bg-primary" style={{ width: `${(r.count / max) * 100}%` }} />
                </div>
              </li>
            ))}
          </ul>
          {oldest != null && (
            <p className="mt-3 text-sm text-muted-foreground" data-testid="atelier-oldest">
              Longest wait: <span className="font-semibold text-foreground">{oldest === 1 ? '1 day' : `${oldest} days`}</span>
            </p>
          )}
        </>
      )}
    </BlockCard>
  );
}
